<template>
	<div class="new">
		<div class="new-header">
			<span class="title">编辑排水户信息</span>
			<el-button type="primary" class="return" @click='returnMain'>返回</el-button>
		</div>
		<div class="new-wrapper" ref="newWrapper" :style='styleObject'>
			<el-scrollbar style="height:100%" :native="false" :noresize="false">
				<div class="new-content">
					<div class="content-item">
						<div class="title">
							<span>基本情况</span>
						</div>
						<el-form :inline="true" :model="param" label-width="120px" :rules="rules" ref="param">
							<el-form-item label="申请单位" prop='companyName'>
								<el-input v-model="param.companyName" placeholder="请输入单位名称"></el-input>
							</el-form-item>
							<el-form-item label="单位地址" label-width="120px">
								<el-input v-model="param.companyAddress" placeholder="请输入单位地址"></el-input>
							</el-form-item>
							<el-form-item label="区域" prop='regionValue' label-width="120px">
								<el-select v-model="param.regionValue" placeholder="请选择">
									<el-option v-for="item in regionOptions" :key="item.value" :label="item.value" :value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="法定代表人">
								<el-input v-model="param.corporation" placeholder="请输入法定代表人"></el-input>
							</el-form-item>
							<el-form-item label="代表人联系方式">
								<el-input v-model="param.corporationWay" placeholder="请输入代表人的联系方式"></el-input>
							</el-form-item>
							<el-form-item label="排水户类别" prop='comTypeValue'>
								<el-select v-model="param.comTypeValue" placeholder="请选择">
									<el-option v-for="item in comTypeOptions" :key="item.value" :label="item.value" :value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="排水户行业性质" prop='comInsTypeValue'>
								<el-select v-model="param.comInsTypeValue" placeholder="请选择">
									<el-option v-for="item in comInsTypeOptions" :key="item.value" :label="item.value" :value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="单位联系人">
								<el-input v-model="param.contacts" placeholder="请输入单位联系人"></el-input>
							</el-form-item>
							<el-form-item label="联系人联系方式">
								<el-input v-model="param.contactWay" placeholder="请输入单位联系人的联系方式"></el-input>
							</el-form-item>
							<el-form-item label="上传营业执照" class="upload">
								<el-upload class="upload-demo" action="" :limit="5" :on-exceed="handleExceed" :on-remove="handleRemove" :before-remove="beforeRemoveCompany" :http-request="uploadCompanyFile" :file-list="companyFileList">
									<el-button size="small" type="primary">点击上传</el-button>
									<div slot="tip" class="el-upload__tip uploadTip">只能上传jpg/png文件</div>
								</el-upload>
							</el-form-item>

							<div class="title">
								<span>许可证信息</span>
							</div>

							<el-form-item prop="licensenum" label="许可证编号">
								<el-input v-model="param.licensenum"></el-input>
							</el-form-item>
							<el-form-item prop="licensedate" label="发证时间">
								<el-date-picker v-model="param.licensedate" type="date" placeholder="选择发证时间" :picker-options="licensedateOption" @change="selectLicenseDate">
								</el-date-picker>
							</el-form-item>
							<el-form-item prop="expirationdate" label="有效期">
								<el-date-picker v-model="param.expirationdate" type="date" placeholder="选择有效期" :picker-options="indateOption" @change="selectExpirationdate">
								</el-date-picker>
							</el-form-item>

							<div class="title">
								<span>项目情况</span>
							</div>
							<el-form-item label="排水项目名称" prop='projectName'>
								<el-input v-model="param.projectName" placeholder="请输入项目名称"></el-input>
							</el-form-item>
							<el-form-item label="详细地址">
								<el-input v-model="param.projectAddress" placeholder="请输入项目详细地址"></el-input>
							</el-form-item>
							<el-form-item label="申请日期" prop='applyDate'>
								<el-date-picker v-model="param.applyDate" type="date" value-format="yyyy-MM-dd" placeholder="选择申请日期">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="勘查编号">
								<el-input v-model="param.surveyNum" placeholder="请输入勘查编号"></el-input>
							</el-form-item>
							<div class="title">
								<span>用水量（m³/日）</span>
							</div>
							<el-form-item label="总用水量" prop='waterusedTotal'>
								<el-input v-model="param.waterusedTotal" placeholder="请输入总用水量"></el-input>
								<span class="item-unit">m³</span>
							</el-form-item>
							<el-form-item label="其中自来水量" prop='tapwateraMount'>
								<el-input v-model="param.tapwateraMount" placeholder="请输入自来水量"></el-input>
								<span class="item-unit">m³</span>
							</el-form-item>
							<el-form-item label="其中自备水量" prop='prewateraMount'>
								<el-input v-model="param.prewateraMount" placeholder="请输入自备水量"></el-input>
								<span class="item-unit">m³</span>
							</el-form-item>
							<div class="title">
								<span>排水量（m³/日）</span>
							</div>
							<el-form-item label="总排水量" prop='drainageTotal'>
								<el-input v-model="param.drainageTotal" placeholder="请输入总排水量"></el-input>
								<span class="item-unit">m³</span>
							</el-form-item>
							<el-form-item label="生产(含餐饮)污水量" prop='productSewage'>
								<el-input v-model="param.productSewage" placeholder="请输入生产污水量"></el-input>
								<span class="item-unit">m³</span>
							</el-form-item>
							<el-form-item label="生活污水量" prop='domesticSewage' label-width="130px">
								<el-input v-model="param.domesticSewage" placeholder="请输入生活污水量"></el-input>
								<span class="item-unit">m³</span>
							</el-form-item>
							<div class="title">
								<span>污水处理方式</span>
								<div class="content-radio">
									<el-radio v-model="param.disposalMethod" label="自行处理">自行处理</el-radio>
									<el-radio v-model="param.disposalMethod" label="委托处理">委托处理</el-radio>
								</div>
							</div>
							<el-form-item label="污水处理工艺" prop='disposalProcess' label-width="120px">
								<el-select v-model="param.disposalProcess" placeholder="请选择">
									<el-option v-for="item in dealOptions" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<div class="title">
								<span>住宅类（包括商住、商办等）</span>
							</div>
							<el-form-item label="基地面积" prop='baseArea'>
								<el-input v-model="param.baseArea" placeholder="请输入基地面积"></el-input>
								<span class="item-unit">m³</span>
							</el-form-item>
							<el-form-item label="总建筑面积" prop='totalArea'>
								<el-input v-model="param.totalArea" placeholder="请输入总建筑面积"></el-input>
								<span class="item-unit">m³</span>
							</el-form-item>
							<el-form-item label="住宅面积" prop='houseArea'>
								<el-input v-model="param.houseArea" placeholder="请输入住宅面积"></el-input>
								<span class="item-unit">m³</span>
							</el-form-item>
							<el-form-item label="商场面积" prop='marketArea'>
								<el-input v-model="param.marketArea" placeholder="请输入商场面积"></el-input>
								<span class="item-unit">m³</span>
							</el-form-item>
							<el-form-item label="办公楼面积" prop='officetArea'>
								<el-input v-model="param.officetArea" placeholder="请输入办公楼面积"></el-input>
								<span class="item-unit">m³</span>
							</el-form-item>
							<el-form-item label="餐饮面积" prop='cateringArea'>
								<el-input v-model="param.cateringArea" placeholder="请输入餐饮面积"></el-input>
								<span class="item-unit">m³</span>
							</el-form-item>
							<div class="title">
								<span>产业类（包括宾馆、医院、餐饮等）</span>
							</div>
							<el-form-item label="主要产品或服务" class='textareaform' :inline="false">
								<el-input type="textarea" v-model="param.mainProducts" placeholder="请输入主要产品或服务"></el-input>
							</el-form-item>
							<el-form-item label="主要原料" class='textareaform' :inline="false">
								<el-input type="textarea" v-model="param.mainMaterials" placeholder="请输入主要原料"></el-input>
							</el-form-item>
							<el-form-item label="污水生产工艺及污染物产生流程（框图，可附图）" class="lhstyle textareaform" :inline="false">
								<el-input type="textarea" v-model="param.mainProcess" placeholder="请输入流程"></el-input>
							</el-form-item>
							<!--<el-form-item label="上传附件" class="upload">
              <el-upload
                class="upload-demo"
                action=""
                :limit="5"
                :on-exceed="handleExceed"
                :http-request="uploadProjectFile"
                :file-list="projectFileList">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip uploadTip">只能上传jpg/png文件，且不超过500kb</div>
              </el-upload>
            </el-form-item>-->
							<el-form-item label="污水处理工艺流程（框图，可附图）" class="lhstyle textareaform" :inline="false">
								<el-input type="textarea" v-model="param.treatmentProcess" placeholder="请输入流程"></el-input>
							</el-form-item>

							<div class="title">
								<span>附件列表</span>
							</div>
							<el-form-item label="上传附件" class="upload">
								<el-upload class="upload-demo" action="" :limit="5" :on-exceed="handleExceed" :http-request="uploadProjectFile" :file-list="projectFileList" :before-remove="beforeRemoveProject">
									<el-button size="small" type="primary">点击上传</el-button>
									<div slot="tip" class="el-upload__tip uploadTip">只能上传jpg/png文件</div>
								</el-upload>
							</el-form-item>
							<!-- <div class="title">
              <span>项目类型</span>
            </div>
            <div class="myTable">
              <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="id" label="序号" width='50px'>
                </el-table-column>
                <el-table-column prop="date" label="项目名称">
                </el-table-column>
                <el-table-column prop="name" label="最高浓度（mg/L）">
                </el-table-column>
              </el-table>
              <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="id" label="序号" width='50px'>
                </el-table-column>
                <el-table-column prop="date" label="项目名称">
                </el-table-column>
                <el-table-column prop="name" label="最高浓度（mg/L）">
                </el-table-column>
              </el-table>
              <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="id" label="序号" width='50px'>
                </el-table-column>
                <el-table-column prop="date" label="项目名称">
                </el-table-column>
                <el-table-column prop="name" label="最高浓度（mg/L）">
                </el-table-column>
              </el-table>
            </div> -->
						</el-form>
					</div>
					<!-- 审批暂时隐藏 -->
					<!--         <div class="content-item">
          <div class="title">
            <span>是否发证</span>
          </div>
          <div class="fzradio">
            <el-radio v-model="radio" label="1">自行处理</el-radio>
            <el-radio v-model="radio" label="2">委托处理</el-radio>
          </div>
          <div>
            <el-form :inline="true" :model="formInline" label-width="120px">
              <el-form-item label="排水许可证编号">
                <el-input v-model="formInline.user"></el-input>
              </el-form-item>
              <el-form-item label="许可日期">
                <el-input v-model="formInline.user"></el-input>
              </el-form-item>
            </el-form>
            <el-form :inline="true" :model="formInline" label-width="120px">
              <el-form-item label="上传附件" class="upload">
                <el-upload class="upload-demo clearfix" action="https://jsonplaceholder.typicode.com/posts/" :on-change="handleChange" :file-list="fileList3">
                  <el-button size="small" type="primary">浏览</el-button>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="content-item">
          <div class="title">
            <span>审核及审批</span>
          </div>
          <div class="subContent">
            <div class="shbmyj">
              <div class="title">审核部门意见</div>

              <el-form :model="formInline" label-width="120px">
                <el-form-item label="初审意见" class="lhstyle">
                  <el-input type="textarea" v-model="formInline.user"></el-input>
                </el-form-item>
              </el-form>

              <el-form :inline="true" :model="formInline" label-width="120px">
                <el-form-item label="初审人">
                  <el-select v-model="value" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="初审日期">
                  <el-date-picker v-model="value1" type="date" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-form>
              <el-form :model="formInline" label-width="120px">
                <el-form-item label="复审意见" class="lhstyle">
                  <el-input type="textarea" v-model="formInline.user"></el-input>
                </el-form-item>
              </el-form>

              <el-form :inline="true" :model="formInline" label-width="120px">
                <el-form-item label="复审人">
                  <el-select v-model="value" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="复审日期">
                  <el-date-picker v-model="value1" type="date" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-form>
            </div>
            <div class="spjgyj">
              <div class="title">审批机构意见</div>

              <el-form :model="formInline" label-width="120px">
                <el-form-item label="审批意见" class="lhstyle">
                  <el-input type="textarea" v-model="formInline.user"></el-input>
                </el-form-item>
              </el-form>

              <el-form :inline="true" :model="formInline" label-width="120px">
                <el-form-item label="审批人">
                  <el-select v-model="value" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="审批日期">
                  <el-date-picker v-model="value1" type="date" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div> -->
					<div class="drbutton">
						<el-button type='primary' @click="submitForm('param')">更新</el-button>
						<el-button type='danger' @click="returnMain()">取消</el-button>
					</div>
				</div>
			</el-scrollbar>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'editMessage',
		data() {
			/**
			 * 非必填项外加数字校验
			 */
			var digitalCheck = (rule, value, callback) => {
				var patrn = /^\d+(\.\d+)?$/;
				if(value === '') {
					callback();
				} else {
					if(!patrn.exec(value)) {
						callback(new Error('该字段必须为数字值'));
					} else {
						callback();
					}
				}
			};
			return {
				licensedateOption: {

				},
				indateOption: {

				},
				//				licensedate: '',
				//				expirationdate: '',
				companyId: this.$route.params.companyId,
				projectId: this.$route.params.projectId,
				//				fileUploadUrl: 'http://192.168.200.148:8091/drainagesystem/fileController/upload/single',
				fileUploadUrl: this.basePath + '/fileController/upload/single',
				// 单位文件list
				companyFileList: [],
				// 单位文件list
				projectFileList: [],
				styleObject: {
					height: window.innerHeight - 60 - 40 - 20 - 20 - 60 + 'px'
				},
				formInline: {
					user: '111'
				},
				fileList3: [{
					name: 'food.jpeg',
					url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
				}],
				// 上传的文件集合
				uploadFileList: [],
				// 排水量（m³/日） date
				value1: '',
				// --------------- 参数对象 -------------
				// 所有的参数信息
				param: {
					creater: '',
					companyId: '',
					companyName: '',
					companyAddress: '',
					corporation: '',
					corporationWay: '',
					contacts: '',
					contactWay: '',
					comTypeValue: '',
					comInsTypeValue: '',
					// 营业执照文件对象json
					companyFileInfor: '',
					projectId: '',
					projectName: '',
					applyDate: '',
					surveyNum: '',
					regionValue: '',
					projectAddress: '',
					// 用水量
					waterusedTotal: '',
					tapwateraMount: '',
					prewateraMount: '',
					// 排水量
					drainageTotal: '',
					productSewage: '',
					domesticSewage: '',
					// 处理方式和处理工艺
					disposalMethod: '自行处理',
					disposalProcess: '',
					// 住宅类
					baseArea: '',
					totalArea: '',
					houseArea: '',
					marketArea: '',
					officetArea: '',
					cateringArea: '',
					// 产业类
					mainProducts: '',
					mainMaterials: '',
					mainProcess: '',
					treatmentProcess: '',
					// 项目文件信息
					projectFileInfor: '',
					//发证时间
					licensedate: '',
					//有效期
					expirationdate: ''

				},

				// --------------- 数据源 ---------------
				// 污水处理工艺
				dealOptions: [{
						value: '一级处理'
					},
					{
						value: '二级处理'
					},
					{
						value: '三级处理'
					}
				],
				// 所属区域
				regionOptions: [],
				// 排水户类别
				comTypeOptions: [{
						value: '居民'
					},
					{
						value: '工业'
					},
					{
						value: '商业'
					}
				],
				// 排水户行业性质
				comInsTypeOptions: [{
						value: '一般排水户'
					},
					{
						value: '重点排水户'
					}
				],
				value: '',
				fzRadio: 1,
				restaurants: [],
				// --- 规则校验 ---
				rules: {
					companyName: [{
							required: true,
							message: '请输入单位名称',
							trigger: 'blur'
						},
						{
							max: 100,
							message: '长度需小于100个字符',
							trigger: 'blur'
						}
					],
					projectName: [{
							required: true,
							message: '请输入项目名称',
							trigger: 'blur'
						},
						{
							max: 100,
							message: '长度需小于100个字符',
							trigger: 'blur'
						}
					],
					//发证时间
					licensedate: [],
					//有效期
					expirationdate: [],
					regionValue: [{
						required: true,
						message: '请选择所在区域',
						trigger: 'change'
					}],
					comTypeValue: [{
						required: true,
						message: '请选择排水户类别',
						trigger: 'change'
					}],
					comInsTypeValue: [{
						required: true,
						message: '请选择排水户行业特征',
						trigger: 'change'
					}],
					disposalProcess: [{
						required: true,
						message: '请选择污水处理工艺',
						trigger: 'change'
					}],
					applyDate: [{
						required: true,
						message: '请选择申请日期',
						trigger: 'change'
					}],
					// --- 以下为数字型校验 ---
					waterusedTotal: [{
						validator: digitalCheck,
						trigger: 'blur'
					}],
					tapwateraMount: [{
						validator: digitalCheck,
						trigger: 'blur'
					}],
					prewateraMount: [{
						validator: digitalCheck,
						trigger: 'blur'
					}],
					drainageTotal: [{
						validator: digitalCheck,
						trigger: 'blur'
					}],
					productSewage: [{
						validator: digitalCheck,
						trigger: 'blur'
					}],
					domesticSewage: [{
						validator: digitalCheck,
						trigger: 'blur'
					}],
					baseArea: [{
						validator: digitalCheck,
						trigger: 'blur'
					}],
					totalArea: [{
						validator: digitalCheck,
						trigger: 'blur'
					}],
					houseArea: [{
						validator: digitalCheck,
						trigger: 'blur'
					}],
					marketArea: [{
						validator: digitalCheck,
						trigger: 'blur'
					}],
					officetArea: [{
						validator: digitalCheck,
						trigger: 'blur'
					}],
					cateringArea: [{
						validator: digitalCheck,
						trigger: 'blur'
					}]
				}
			}
		},
		mounted() {
			this.uploadFileList = [];
			if(this.companyId && this.projectId) {
				this.param.companyId = this.companyId;
				this.param.projectId = this.projectId;
				// 获取单位详细信息并填充
				this.findCompanyDetail(this.companyId);
				// 获取项目详细信息并填充
				this.findProjectDetail(this.projectId);
			} else {
				this.returnMain();
			}

			var options = this.filterRegion();
			var arr = [];
			var x;
			for(x in options) {
				if('全部' != options[x].value) {
					arr.push(options[x]);
				}
			}
			this.regionOptions = arr;
		},
		methods: {
			returnMain() {
				this.$router.push('/message/main')
			},
			//发证时间日期控件点击时触发该方法
			selectLicenseDate() {
				this.indateOption = {
					disabledDate: (time) => {
						if(this.param.licensedate != '') {
							return time.getTime() < this.param.licensedate;
						}
					}
				}
				if(this.param.licensedate != '' && this.param.licensedate != null) {
					this.rules.expirationdate = [{
						required: true,
						message: '请选择有效期',
						trigger: 'change'
					}]
				} else {
					this.rules.expirationdate = []
				}
			},
			//有效期日期控件点击时触发该方法
			selectExpirationdate() {
				this.licensedateOption = {
					disabledDate: (time) => {
						if(this.param.expirationdate != '') {
							return time.getTime() > this.param.expirationdate;
						}
					}
				}
				if(this.param.expirationdate != '' && this.param.expirationdate != null) {
					this.rules.licensedate = [{
						required: true,
						message: '请选择申请时间',
						trigger: 'change'
					}]
				} else {
					this.rules.licensedate = []
				}
			},
			// 上传文件方法
			handleChange(file, fileList) {
				this.fileList3 = fileList.slice(-3);
			},
			/**
			 * 获取单位详情
			 * @param  {[type]} companyId [description]
			 * @return {[type]}           [description]
			 */
			findCompanyDetail(companyId) {
				this.$http.post(this.basePath + '/sewerageUser/findCompanyDetailById', {
					//  参数
					companyId: companyId
				}).then((result) => {
					if(result.data.resCode == 1) {
						if(result.data.data != '') {
							var comDetail = JSON.parse(result.data.data);
							this.param.companyName = comDetail.companyname;
							this.param.companyAddress = comDetail.companyaddre;
							this.param.corporation = comDetail.corporation;
							this.param.corporationWay = comDetail.corporationway;
							this.param.contacts = comDetail.contacts;
							this.param.contactWay = comDetail.contactway;
							this.param.comTypeValue = comDetail.seweragetype;
							this.param.comInsTypeValue = comDetail.sewerageindustrytype;
							this.param.regionValue = comDetail.region;
							// 营业执照
							if(comDetail.fileList != '') {
								var fileList = JSON.parse(comDetail.fileList);
								for(var i = 0; i < fileList.length; i++) {
									var dd = fileList[i];
									var fileUrl = this.basePath + this.fileDownloadPath + dd.filepath;
									this.companyFileList.push({
										name: dd.filename,
										url: fileUrl,
										pathName: dd.filepath
									});
								}
							}
						}
					} else {
						console.log(result.data.msg)
					}
				}, (error) => {
					console.log('系统错误，-100');
				});
			},
			/**
			 * 获取项目详情
			 * @param  {[type]} projectId [description]
			 * @return {[type]}           [description]
			 */
			findProjectDetail(projectId) {
				this.$http.post(this.basePath + '/sewerageUser/findProjectDetailById', {
					//  参数
					projectId: projectId
				}).then((result) => {
					if(result.data.resCode == 1) {
						if(result.data.data != '') {
							var proDetail = JSON.parse(result.data.data);
							this.param.projectName = proDetail.projectname;
							this.param.surveyNum = proDetail.surveynum;
							this.param.projectAddress = proDetail.projectaddre;
							this.param.waterusedTotal = (proDetail.waterusedtotal == null) ? '' : proDetail.waterusedtotal;
							this.param.tapwateraMount = (proDetail.tapwateramount == null) ? '' : proDetail.tapwateramount;
							this.param.prewateraMount = (proDetail.prewateramount == null) ? '' : proDetail.prewateramount;
							this.param.drainageTotal = (proDetail.drainagetotal == null) ? '' : proDetail.drainagetotal;
							this.param.productSewage = (proDetail.productsewage == null) ? '' : proDetail.productsewage;
							this.param.domesticSewage = (proDetail.domesticsewage == null) ? '' : proDetail.domesticsewage;
							this.param.disposalMethod = proDetail.disposalmethod;
							this.param.disposalProcess = proDetail.disposalprocess;
							this.param.baseArea = (proDetail.basearea == null) ? '' : proDetail.basearea;
							this.param.totalArea = (proDetail.totalarea == null) ? '' : proDetail.totalarea;
							this.param.houseArea = (proDetail.housearea == null) ? '' : proDetail.housearea;
							this.param.marketArea = (proDetail.marketarea == null) ? '' : proDetail.marketarea;
							this.param.officetArea = (proDetail.officetarea == null ? '' : proDetail.officetarea);
							this.param.cateringArea = (proDetail.cateringarea == null) ? '' : proDetail.cateringarea;
							this.param.mainProducts = proDetail.mainproducts;
							this.param.mainMaterials = proDetail.mainmaterials;
							this.param.mainProcess = proDetail.mainprocess;
							this.param.treatmentProcess = proDetail.treatmentprocess;
							var applyDate = this.time2YMD(proDetail.applydate.time);
							this.param.applyDate = applyDate;
							// 附件
							if(proDetail.fileList != undefined) {
								var fileList = JSON.parse(proDetail.fileList);
								for(var i = 0; i < fileList.length; i++) {
									var dd = fileList[i];
									var fileUrl = this.basePath + this.fileDownloadPath + dd.filepath;
									this.projectFileList.push({
										name: dd.filename,
										url: fileUrl,
										pathName: dd.filepath
									});
								}
							}

						}
					} else {
						console.log(result.data.msg)
					}
				}, (error) => {
					console.log('系统错误，-100');
				});
			},
			// 选择现有的单位
			handleSelect(item) {
				// debugger
				this.param.companyId = item.id;
				// 填充单位信息
				this.param.companyName = item.companyname;
				if(item.regionValue != '') {
					this.param.regionValue = item.regionValue;
				}
				if(item.companyaddre != '') {
					this.param.companyAddress = item.companyaddre;
				}
				if(item.corporation != '') {
					this.param.corporation = item.corporation;
				}
				if(item.corporationway != '') {
					this.param.corporationWay = item.corporationway;
				}
				if(item.contacts != '') {
					this.param.contacts = item.contacts;
				}
				if(item.contactway != '') {
					this.param.contactWay = item.contactway;
				}
				if(item.seweragetype != '') {
					this.param.comTypeValue = item.seweragetype;
				}
				if(item.sewerageindustrytype != '') {
					this.param.comInsTypeValue = item.sewerageindustrytype;
				}
				// 手动触发一下单位的聚焦事件
				// this.$refs.companyNameInput.focus();
			},
			// 校验项目名称是否冲突
			//			projectNameBlurEvent() {
			//				var companyId = this.param.companyId;
			//				var projectName = this.param.projectName;
			//				if(companyId != '' && projectName != '') {
			//					this.$http.post(this.basePath + '/sewerageUser/projectNameCheck', {
			//						//  参数
			//						companyId: companyId,
			//						projectName: projectName
			//					}).then((result) => {
			//						if(result.data.resCode == 1) {
			//							if(result.data.data == 'existed') {
			//								alert('该排水户下已存在该项目名称，请更换');
			//							}
			//						} else {
			//							console.log(result.data.msg)
			//						}
			//					}, (error) => {
			//						console.log('获取单位信息异常');
			//					});
			//				}
			//			},
			submitForm(formName) {
				// 参数规则校验
				this.$refs[formName].validate((valid) => {
					if(valid) {
						this.updateSewerageUser();
					} else {
						return false;
					}
				});
			},
			/**
			 * 创建排水户方法
			 * @return {[type]} [description]
			 */
			updateSewerageUser() {
				if(this.param.licensedate != null && this.param.licensedate != '') {
					this.param.licensedate = this.time2YMD(this.param.licensedate.getTime());
					this.param.expirationdate = this.time2YMD(this.param.expirationdate.getTime());
				}
				var createParam = this.param;
				// 上传的文件
				createParam.uploadFileInfor = JSON.stringify(this.uploadFileList);
				this.$http.post(this.basePath + '/sewerageUser/updateSewerageUser',
					// 参数
					createParam
				).then((result) => {
					if(result.data.resCode == 1) {
						//						alert('排水户更新成功');
						this.$message({
							type: 'success',
							message: '排水户更新成功!'
						});
						// 跳转到列表页
						setTimeout(() => {
							this.$router.push('/message/main')
						}, 500);
					} else {
						//						alert(result.data.msg)
						this.$message({
							type: 'error',
							message: result.data.msg
						});
					}
				}, (error) => {
					//					alert('异常');
					this.$message({
						type: 'error',
						message: '异常!'
					});
				});
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			beforeRemoveCompany(file, fileList) {
				//				this.$confirm('是否删除该营业执照?', '提示', {
				//					confirmButtonText: '确定',
				//					cancelButtonText: '取消',
				//					type: 'warning'
				//				}).then(() => {
				//					$.ajax({
				//						url: this.basePath + '/fileController/deleteFileByRelationAndFilePath/',
				//						type: 'POST',
				//						cache: false,
				//						data: JSON.stringify({
				//							relationNum: this.companyId,
				//							filePath: file.pathName
				//						}),
				//						processData: false,
				//						contentType: false,
				//						success: function(res) {
				//							if(res.resCode == 1) {
				//								//							alert('删除成功')
				//							}
				//						}
				//					});
				//					this.$message({
				//						type: 'success',
				//						message: '删除成功!'
				//					});
				//				}).catch(() => {
				//					this.$message({
				//						type: 'info',
				//						message: '已取消删除'
				//					});
				//				});
				let that = this;
				$.ajax({
					url: this.basePath + '/fileController/deleteFileByRelationAndFilePath/',
					type: 'POST',
					cache: false,
					data: JSON.stringify({
						relationNum: this.companyId,
						filePath: file.pathName
					}),
					processData: false,
					contentType: false,
					success: function(res) {
						if(res.resCode == 1) {
							//							alert('删除成功')
							that.$message({
								type: 'success',
								message: '删除成功!'
							});
						}
					}
				});
			},
			beforeRemoveProject(file, fileList) {
				let that = this;
				$.ajax({
					url: this.basePath + '/fileController/deleteFileByRelationAndFilePath/',
					type: 'POST',
					cache: false,
					data: JSON.stringify({
						relationNum: this.projectId,
						filePath: file.pathName
					}),
					processData: false,
					contentType: false,
					success: function(res) {
						if(res.resCode == 1) {
							//							alert('删除成功')
							that.$message({
								type: 'success',
								message: '删除成功!'
							});
						}
					}
				});
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				// this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
				//								alert(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
				this.$message({
					type: 'error',
					message: `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件!`
				});
			},
			// 上传单位执照
			uploadCompanyFile(param) {
				this.publicFileUpload('company', param);
			},
			// 上传项目文件
			uploadProjectFile(param) {
				this.publicFileUpload('project', param);
			},
			/**
			 * 文件上传公共方法
			 * @param  {[type]} fileType [区分单位文件还是项目文件]
			 * @param  {[type]} param    [description]
			 * @return {[type]}          [description]
			 */
			publicFileUpload(fileType, param) {
				var that = this;
				var maxSize = 10 * 1024 * 1024;
				var fileObj = param.file;
				var fileName = fileObj.name;
				var fileSize = fileObj.size;
				var extension = fileName.substring(fileName.lastIndexOf('.'), fileName.length).toLowerCase();
				if((extension == ".jpg" || extension == ".png") && fileSize < maxSize) {
					var data = new FormData();
					var hz = fileName.substring(fileName.length - 4, fileName.length);
					var filePathName = new Date().getTime() + '_drainage' + hz;
					// 修改上传图片名称
					data.append("file", fileObj, filePathName);
					// 保存文件对象
					var fileObj = {
						filepath: filePathName,
						filename: fileName,
						filetype: fileType //文件类型（单位？项目？）
					}
					$.ajax({
						url: that.fileUploadUrl,
						type: 'POST',
						cache: false,
						data: data,
						processData: false,
						contentType: false,
						success: function(res) {
							if(res.resCode == 1) {
								that.uploadFileList.push(fileObj);
							}
						}
					});
				} else {
					//					alert('请选择jpg、png格式，且小于10M的文件');
					this.$message({
						type: 'error',
						message: '请选择jpg、png格式，且小于10M的文件'
					});

					return;
				}
			}
		}
	}
</script>
<style lang="stylus" scoped>
	.new-wrapper >>> .el-scrollbar__wrap {
		overflow-x: hidden;
	}

	.textareaform >>> .el-form-item__label {
		float: left;
		line-height: 2
	}

	.textareaform >>> .el-form-item {
		width: 100%;
	}

	.textareaform >>> .el-form-item__content {
		width: 80%;
		float: left;
	}

	.textareaform >>> .el-textarea__inner {
		resize: none;
		height: 100px;
	}

	.drbutton >>> .el-button--primary {
		border-color: #3E82F7;
	}

	.drbutton >>> .el-button {
		font-size: 12px;
		border-radius: 2px;
	}

	.content-item >>> .el-input {
		width: inherit;
		margin: 0 10px;
		font-size: 12px;
		color: #262626;
	}

	.content-item >>> .el-form-item__label {
		font-size: 12px;
		color: #262626;
		padding: 0;
	}

	.content-item >>> .el-form--inline .el-form-item {
		margin-right: 20px;
	}

	.content-item >>> .el-textarea {
		display: inline-block;
		width: 100%;
		vertical-align: bottom;
		font-size: 12px;
		margin: 0 10px;
	}

	.content-item >>> .el-textarea__inner {
		resize: none;
		height: 100px;
	}

	.content-item >>> .el-upload {
		display: inline-block;
		text-align: center;
		cursor: pointer;
		outline: 0;
		float: right;
	}

	.content-item >>> .el-upload-list {
		margin: 0;
		padding: 0;
		list-style: none;
		float: left;
		width: 310px;
		border: 1px solid #ccc;
		margin: 0 10px;
		padding: 5px 10px;
		min-height: 38px;
	}

	.content-item >>> .el-upload__tip {
		margin-top: 0;
	}

	.content-item >>> .el-upload-list__item {
		-webkit-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
		transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
		font-size: 14px;
		color: #606266;
		line-height: 1.8;
		margin-top: 0px;
		position: relative;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		border-radius: 4px;
		width: 100%;
	}

	.content-item >>> .el-table {
		flex: 1;
	}

	.content-item >>> .el-table td,
	.el-table th {
		padding: 3px 0;
		min-width: 0;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		text-overflow: ellipsis;
		vertical-align: middle;
		position: relative;
	}

	.content-item >>> .el-table th > .cell {
		position: relative;
		word-wrap: normal;
		text-overflow: ellipsis;
		vertical-align: middle;
		width: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		font-size: 12px;
		color: #262626;
	}

	.content-item >>> .el-table .cell {
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		white-space: normal;
		word-break: break-all;
		line-height: 23px;
		font-size: 12px;
	}

	.new {
		.new-header {
			height: 60px;
			line-height: 60px;
			border-bottom: 1px solid #E2E7EB;
			padding: 0 20px;
			.title {
				font-size: 18px;
				color: #262626;
				float: left;
			}
			.return {
				float: right;
				margin-top: 10px;
			}
		}

		.new-wrapper {
			position: relative;
			overflow: hidden;
			.new-content {
				padding: 20px;

				.content-item {
					margin-bottom: 10px;

					.title {
						height: 40px;

						& > span {
							&:first-child {
								font-size: 14px;
								color: #262626;
								font-weight: 700;
							}
						}

						.date {
							float: right;

							span {
								font-size: 12px;
								color: #262626;
							}
						}

						.content-radio {
							display: inline-block;
							margin-left: 40px;
						}
					}

					.fzradio {
						display: inline-block;
						margin-left: 130px;
						margin-bottom: 20px;
					}

					.subContent {
						.title {
							height: 40px;
							font-size: 12px;
							color: #262626;
							font-weight: 700;
						}
					}

					.item-name,
					.item-unit {
						width: 117px;
						text-align: right;
						font-size: 12px;
						color: #262626;
						letter-spacing: 0;
					}

					.item-unit {
						text-align: left;
					}

					.textareaform {
						width: 100%
						display flex;
					}
					.upload {
						display: block;
					}

					.uploadTip {
						margin-left: 20px;
						width: 300px;
					}
					.lhstyle {
						label {
							line-height: 20px;
						}
					}
					.myTable {
						display: flex;
					}
				}

				.drbutton {
					text-align: center;
				}
			}
		}
	}
</style>
</style>



// WEBPACK FOOTER //
// src/components/message/components/editMessage.vue